import { Checkbox, IconButton, TableCell, TableRow, useTheme } from '@mui/material'

import { useMe, useTableItemsCheck } from 'src/hooks'

import { IRewardPointsBaseWithId } from 'src/types'
import { getTableTimestamp } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import EditIcon from '@mui/icons-material/Edit'
import { useState } from 'react'
import { UpdateRewardPointForm } from '../forms/update/form-wrapper.component'

interface IProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IRewardPointsBaseWithId
}

export const TableItem = ({ row, isItemSelected, handleItemCheck }: IProps) => {
  const { data: user } = useMe()

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const theme = useTheme()

  return (
    <>
      <TableRow>
        <TableCell align="center">
          <Checkbox
            checked={isItemSelected(row.id)}
            onChange={handleItemCheck(row.id)}
            sx={{ color: theme.palette.custom.grey2 }}
          />
        </TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.description}</TableCell>
        <TableCell align="center">{row.amount}</TableCell>
        <TableCell align="center">{row.type}</TableCell>
        <TableCell align="center">
          {row.default ? <HelperWrapper t="yes-label" /> : <HelperWrapper t="no-label" />}
        </TableCell>
        <TableCell align="center" sx={{ fontSize: '11px' }}>
          {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell width="24%" align="center">
          <IconButton onClick={handleOpen}>
            <EditIcon />
          </IconButton>
        </TableCell>
      </TableRow>
      <UpdateRewardPointForm
        handleClose={handleClose}
        open={open}
        id={row.id}
        initial={{
          type: row.type,
          amount: Number(row.amount),
          default: row.default,
          name: row.name,
          description: row.description,
          scans_to_complete: row?.payload?.scans_to_complete,
        }}
      />
    </>
  )
}
